// extracted by mini-css-extract-plugin
export var alwaysBig = "Button-module--alwaysBig--2017c";
export var alwaysSmall = "Button-module--alwaysSmall--2312c";
export var babylist = "Button-module--babylist--e058d";
export var button = "Button-module--button--71436";
export var disabled = "Button-module--disabled--5a30b";
export var disabledCursor = "Button-module--disabledCursor--f53e9";
export var fullWidth = "Button-module--fullWidth--92961";
export var icon = "Button-module--icon--f13a2";
export var iconGap = "Button-module--iconGap--34966";
export var iconLeft = "Button-module--iconLeft--06a69";
export var iconStyle = "Button-module--iconStyle--f6b67";
export var input = "Button-module--input--121d0";
export var inputWithIcon = "Button-module--inputWithIcon--90e03";
export var inverted = "Button-module--inverted--5b5d0";
export var large = "Button-module--large--c19a0";
export var navigation = "Button-module--navigation--67c7f";
export var noBg = "Button-module--noBg--03e94";
export var noPaddingInline = "Button-module--noPaddingInline--d0166";
export var outlined = "Button-module--outlined--55657";
export var play = "Button-module--play--f6071";
export var primary = "Button-module--primary--46423";
export var secondary = "Button-module--secondary--534da";
export var special = "Button-module--special--53968";
export var standard = "Button-module--standard--c35e8";
export var tiny = "Button-module--tiny--aee54";
export var tinyFilled = "Button-module--tinyFilled--76bef";
export var white = "Button-module--white--667ab";